<template>
  <v-dialog :value="value"
            @input="toggleModal"
            persistent
            width="500px">
    <v-card>
      <v-toolbar color="primary" flat dense dark>
        <v-icon class="mr-2">
          {{icon || 'mdi-alert-circle-outline'}}
        </v-icon>

        <v-toolbar-title>{{title || 'Error'}}</v-toolbar-title>
        <v-spacer/>
        <v-icon @click="toggleModal">mdi-close</v-icon>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="mt-5">
            {{message}}
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn text
               color="primary"
               @click="toggleModal(false)">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  methods: {
    toggleModal (value) {
      this.$emit('input', value)
    }
  },
  props: ['value', 'message', 'icon', 'title']
}
</script>
